import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Http, HttpModule, XHRBackend, RequestOptions } from '@angular/http';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SimpleNotificationsModule } from 'angular2-notifications';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpService } from './shared/services/http.interceptor.service';
import { HttpFactory } from './shared/services/http.factory';
import { AuthGuard, FetchToken, AllowAppointmenttypePanel, AllowAppointmentTemplatePanel, AllowAppointmentCalendarPanel, IsOtherDomain } from './shared/services/auth-guard.service';
import { SecurityService, UserInfoService, GetToken } from './shared/services/security.service';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { SlotsModule } from './slots/slots.module';
import { SharedModule } from './shared/shared.module';
import { LoaderSpinnerModule } from './shared/loader-spinner/index'
import { TooltipModule } from 'ngx-bootstrap';
import { CssVarsService } from './shared/services/cssVarsService.service';
import { CalendarEventFileModule } from './calendar-event-files/calendat-event-file.module';
import { RecruiterRescheduleComponent } from './recruiter-reschedule/recruiter-reschedule.component';
import { RecruiterCancelComponent } from './recruiter-cancel/recruiter-cancel.component';
import { RecruiterRescheduleModule } from './recruiter-reschedule/recruiter-reschedule.module';
import { RecruiterCancelModule } from './recruiter-cancel/recruiter-cancel.module';
import { CustomDomainResolve } from './slots/slots.resolve';
import { CustomDomainRedirectComponent } from './custom-domain-redirect/custom-domain-redirect.component';

export function HttpLoaderFactory(http: HttpClient) {
  // for development
  // return new TranslateHttpLoader(http, '/start-angular/SB-Admin-BS4-Angular-4/master/dist/assets/i18n/', '.json');
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    UnauthorizedComponent,
    CustomDomainRedirectComponent
  ],
  imports: [
    CalendarEventFileModule,
    RecruiterRescheduleModule,
    RecruiterCancelModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    SlotsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    LoaderSpinnerModule,
    SimpleNotificationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    TooltipModule.forRoot()
  ],
  providers: [
    {
      provide: HttpService,
      useFactory: HttpFactory,
      deps: [XHRBackend, RequestOptions]
    },
    {
      provide: Http,
      useExisting: HttpService
    },
    AuthGuard,
    SecurityService,
    UserInfoService,
    FetchToken,
    AllowAppointmenttypePanel,
    AllowAppointmentTemplatePanel,
    AllowAppointmentCalendarPanel,
    GetToken,
    CssVarsService,
    CustomDomainResolve,
    IsOtherDomain
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts